import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";
import { List } from "react-bootstrap-icons";

import LoadingSpinner from "../../components/LoadingSpinner";
import Posts from "./Posts";
import Classes from "./Classes";
import PaymentOptions from "./PaymentOptions";
import Members from "./Members";
import Earnings from "./Earnings";
import BookingsAndShedule from "./BookingsAndShedule";
import Settings from "./Settings";
import Coupon from "./coupon/Coupon";
import BasicClubInfo from "./BasicClubInfo";

import "./MyOneClub.css";
import ClubPolicy from "./ClubPolicy";
import Embedded from "./embedded/Embedded";
import ChangePlan from "./changePlan/ChangePlan";

export default function MyOneClub() {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [currentView, setCurrentView] = useState(null);
  const [showMenuHint, setShowMenuHint] = useState(true);


  const goToChangePlan = () => {
    setCurrentView("ChangePlan")
  }



  const renderComponent = () => {
    switch (currentView) {
      case "BasicInfo":
        return <BasicClubInfo id={id} />;
      case "Posts":
        return <Posts id={id} />;
      case "Classes":
        return <Classes id={id} />;
      case "BookingsAndShedule":
        return <BookingsAndShedule id={id} />;
      case "PaymentOptions":
        return <PaymentOptions id={id} />;
      case "Members":
        return <Members id={id} />;
      case "Earnings":
        return <Earnings id={id} />;
      case "Settings":
        return <Settings id={id} />;
      case "Coupon":
        return <Coupon id={id} />;
           case "ClubPolicy":
        return <ClubPolicy clubId={id} />;
        case "Embedded":
          return <Embedded id={id} goToChangePlan={goToChangePlan}/>;
          case "ChangePlan":
          return <ChangePlan id={id}/>;
      default:
        return <BasicClubInfo id={id} />;
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div>
      <div className="container bg-white">
        <hr className="m-0" />

        <div className="d-flex justify-content-end p-2 position-relative">
          {showMenuHint && (
            <div className="me-2 bg-warning text-dark px-2 py-1 rounded shadow fade show">
              Club Admin Menu 👉
            </div>
          )}
          <NavDropdown 
          onClick={() => setShowMenuHint(false)}
            title={<List size={40} />}
            id="myoneclub-dropdown"
            className="custom-dropdown"
            align="end"
          >
            <NavDropdown.Item onClick={() => setCurrentView("BasicInfo")}>
              Basic Info
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => setCurrentView("Posts")}>
              Posts
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => setCurrentView("BookingsAndShedule")}>
              Bookings And Schedule
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => setCurrentView("Classes")}>
              Classes
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => setCurrentView("PaymentOptions")}>
              Payment Options
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => setCurrentView("Members")}>
              Members
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => setCurrentView("Earnings")}>
              Earnings
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => setCurrentView("Settings")}>
              Settings
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => setCurrentView("Coupon")}>
              Coupon
            </NavDropdown.Item>
                 <NavDropdown.Item onClick={() => setCurrentView("Embedded")}>
             Embedded
            </NavDropdown.Item>
                     <NavDropdown.Item onClick={() => setCurrentView("ChangePlan")}>
             Change Plan
            </NavDropdown.Item>
               <NavDropdown.Item onClick={() => setCurrentView("ClubPolicy")}>
              Club Policy
            </NavDropdown.Item>
          </NavDropdown>
        </div>

        <div>{renderComponent()}</div>
      </div>
    </div>
  );
}
